module.exports = __webpack_public_path__ + "img/google-play-store.38030101.png";